import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { NavLink, useLocation } from "react-router-dom";
import { useMediaQuery } from "react-responsive";
import "../../constants/css/custom_styles.css";
import { HiHome } from "react-icons/hi";
import { GiMedicinePills, GiMedicines } from "react-icons/gi";
import { MdDewPoint } from "react-icons/md";

const MedicalSidebar = () => {
    const location = useLocation();
    let isTab = useMediaQuery({ query: "(max-width: 768px)" });
    const [isOpen, setIsOpen] = useState(isTab ? false : true);

    const [isActive, setIsActive] = useState({
        medicines: false,
        medicine_invoice: false,
        issued_medicines: false,
    });

    useEffect(() => {
        setIsOpen(!isTab);
    }, [isTab]);

    useEffect(() => {
        const path = location.pathname;

        setIsActive({
            medicines:
                path === "/medical/home" ||
                (path.includes("/medical/medicines") &&
                    !path.includes("/medical/medicines/add")),
            medicine_invoice: path.includes("/medical/invoice-medicine"),
            issued_medicines: path.includes("/medical/issued-medicines"),
        });
    }, [location.pathname]);

    const handleIsActive = (key) => {
        setIsActive((prevState) => ({
            ...prevState,
            [key]: !prevState[key],
        }));
    };

    return (
        <motion.div
            initial={{ x: -250 }}
            animate={{ x: isOpen ? 0 : -250 }}
            className="bg-secondary text-[#ffffff] shadow-xl w-[16rem] max-w-[16rem] h-full md:overflow-y-scroll 2xl:overflow-hidden md:relative fixed pl-2"
        >
            <div className="flex flex-col justify-between h-full">
                <div
                    className={`text-md whitespace-pre pb-2 pt-4 flex flex-row gap-2 font-bold ${isOpen ? "block" : "hidden"}`}
                >
                    <HiHome size={18} />
                    Medical
                </div>
                <hr className="border-white my-2" />
                <div className="overflow-y-auto flex-1">
                    <div className="flex flex-col h-full">
                        <ul className="whitespace-pre px-2.5 text-[0.9rem] py-3 flex flex-col gap-2 font-medium scrollbar-thin h-full md:h-full">
                            <li>
                                <NavLink
                                    to="/medical/home"
                                    className={`flex gap-3 pl-1 pr-1 py-2 ${isActive.medicines ? "bg-primary rounded-md" : ""}`}
                                    onClick={() => handleIsActive("medicines")}
                                >
                                    <GiMedicinePills size={18} />
                                    <p className={`whitespace-pre text-xs ${isOpen ? "block" : "hidden"}`}>
                                        Medicines
                                    </p>
                                </NavLink>
                            </li>
                            <li>
                                <NavLink
                                    to="/medical/invoice-medicine"
                                    className={`flex gap-3 pl-1 pr-1 py-2 ${isActive.medicine_invoice ? "bg-primary rounded-md" : ""}`}
                                    onClick={() => handleIsActive("medicine_invoice")}
                                >
                                    <GiMedicines size={18} />
                                    <p className={`whitespace-pre text-xs ${isOpen ? "block" : "hidden"}`}>
                                        Medicine Invoice
                                    </p>
                                </NavLink>
                            </li>
                            <li>
                                <NavLink
                                    to="/medical/issued-medicines"
                                    className={`flex gap-3 pl-1 pr-1 py-2 ${isActive.issued_medicines ? "bg-primary rounded-md" : ""}`}
                                    onClick={() => handleIsActive("issued_medicines")}
                                >
                                    <MdDewPoint size={18} />
                                    <p className={`whitespace-pre text-xs ${isOpen ? "block" : "hidden"}`}>
                                        Issued Medicines
                                    </p>
                                </NavLink>
                            </li>
                        </ul>
                    </div>
                </div>
                <p className="text-[0.8rem] mb-4">
                    © Developed By: Rashail Tech. Labs
                </p>
            </div>
        </motion.div>
    );
};

export default MedicalSidebar;
